import './scss/index.scss';
import ComponentsFactory from 'foundation/components-factory';
import DfpBanner from './js/dfp-banner.component';

ComponentsFactory.getInstance().define('dfp-banner', DfpBanner);
